import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class NotificationUsersModel extends BaseModel {

    constructor() {
        super({
                name: "notification_users",
                tableName: 'notification_users',
                label: "Thông Báo Người dùng",
                display_key: 'name',
                default_order: { key: 'updated_at', direction: 'asc' }
            },
            {
                id: {
                    name: "id",
                    display: false
                },
                uid: {
                    name: 'uid',
                    display: false
                },
                notification_id: {
                    name: 'notification_id',
                    display: false
                },
            },
            )
    }

}